export default "__VITE_ASSET__8fb3c81f__"